@if (exportDisplay) {
  <div class="flex flex-col gap-3 px-6 py-3">
    <div class="flex flex-col justify-between w-full">
      <div class="flex flex-row gap-3 truncate">
        <!-- <img class="w-10 h-10 rounded-md overflow-hidden" [src]="document.url"> -->
        @if (exportDisplay.export.status !== 'COMPLETED') {
          <mat-icon
            >cloud_download</mat-icon
            >
          } @else {
            <mat-icon>download_done</mat-icon>
          }
          <div class="flex flex-col truncate">
            <div class="text-md font-medium truncate">
              {{ exportDisplay.name }}
            </div>
          </div>
        </div>
        <div class="flex justify-end">
          <div class="self-end mt-auto">
            @if (exportDisplay.export.s3Url) {
              <a
                [href]="exportDisplay.export.s3Url"
                download
                class="cursor-pointer underline text-md text-secondary"
                >Download</a
                >
              }
            </div>
          </div>
        </div>
        @if (exportDisplay.export.status !== 'COMPLETED') {
          <mat-progress-bar
            mode="indeterminate"
          ></mat-progress-bar>
        }
      </div>
    }
